module.exports = __webpack_public_path__ + "img/paris4.2ef54f2b.jpeg";